const WineLocator = {
	init: function() {
		// console.log('WineLocator specific code');
	}
}

export default WineLocator